import Header from "./components/Header";
import CryptoCurrency from "./pages/CryptoCurrency";

function App() {
  return (
    <div className="app">
      <Header />
      <CryptoCurrency />
    </div>
  );
}

export default App;
